import React from "react";

const PrivacyConfirmed = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Email Confirmed</h2>

      <p style={styles.text}>
        Thank you for confirming your email address.
      </p>

      <p style={styles.text}>
        Your privacy request has been verified and will be processed in
        accordance with applicable privacy laws.
      </p>

      <p style={styles.subtle}>
        You do not need to take any further action at this time.
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "520px",
    margin: "0 auto",
    padding: "32px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    textAlign: "center"
  },
  heading: {
    marginBottom: "16px"
  },
  text: {
    marginBottom: "14px",
    color: "#444"
  },
  subtle: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#666"
  }
};

export default PrivacyConfirmed;
